import(/* webpackMode: "eager" */ "/vercel/path0/src/app/report/page.tsx");
